import { gql } from 'urql';

const GetEmployment = gql`
  query Occupations {
    occupations {
      name
      description
    }
  }
`;

export default GetEmployment;
